module.exports = __webpack_public_path__ + "img/icn_check_taichou.796fe7ad.png";